import { currency } from "../pharmacy/Utility/currency";

export default function SummaryPanel({ totals }) {
  if (!totals) return null;

  return (
    <div
      style={{
        padding: "20px",
        background:
          "linear-gradient(135deg, rgb(51 75 99) 0%, rgb(51 77 100) 100%)",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          gap: "12px",
          marginBottom: "16px",
        }}
      >
        {[
          { k: "totalProducts", label: "Total Items" },
          { k: "taxableAmount", label: "Taxable Amount", fmt: currency },
          { k: "gstAmount", label: "Tax (CGST + SGST)", fmt: currency },
          { k: "roundOff", label: "Round Off", fmt: currency },
        ].map((b) => (
          <div
            key={b.k}
            style={{
              background: "rgba(255,255,255,0.05)",
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid rgba(255,255,255,0.1)",
            }}
          >
            <div
              style={{
                fontSize: "10px",
                fontWeight: 600,
                color: "#9ca3af",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginBottom: "4px",
              }}
            >
              {b.label}
            </div>
            <div style={{ fontSize: "18px", fontWeight: 700, color: "#fff" }}>
              {b.fmt ? b.fmt(totals[b.k]) : totals[b.k]}
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
          padding: "10px",
          borderRadius: "8px",
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          gap: "12px",
          alignItems: "center",
          boxShadow: "0 10px 25px rgba(16, 185, 129, 0.3)",
        }}
      >
        <div>
          <div
            style={{
              fontSize: "11px",
              fontWeight: 600,
              color: "rgba(255,255,255,0.8)",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            Total Payable
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "22px", fontWeight: 700, color: "#fff" }}>
            {currency(totals.payable)}
          </div>
        </div>
      </div>
    </div>
  );
}
